import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@nuxtjs/composition-api";

import { useCategories } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCategories',
  setup(__props) {

const { categoriesList } = useCategories();

// Should only show first 4, the rest just serve as fallbacks incase the primary bubbles are not available
const homeCategories = ["ltkseasonal", "ltkhome", "ltkactive", "ltkfamily", "ltktravel", "ltkbeauty", "ltkbaby"];

const homeCategoryBubblesCount = 4;

const categories = computed(() =>
  homeCategories.filter((item) => categoriesList.value.includes(item)).slice(0, homeCategoryBubblesCount),
);

return { __sfc: true,categoriesList, homeCategories, homeCategoryBubblesCount, categories }
}

})